import { Table } from '@mantine/core'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { DeploymentGroup } from '@/types/deploymentGroup'
import { Device } from '@/types/device'
import { getDevicesCameras } from '@/utils/device/getDeviceAttr'
import { GroupMemberRow } from './GroupMemberRow'
import { DeploymentGroupRowSlots } from './deploymentTreeTypes'

type GroupMemberTableProps = Pick<
  DeploymentGroupRowSlots,
  'renderMemberActions' | 'onOpenGroup'
> & {
  group: DeploymentGroup
  device?: Device
  highlightedStreamId?: string
}

export const GroupMemberTable = ({
  group,
  device,
  highlightedStreamId,
  renderMemberActions,
  onOpenGroup
}: GroupMemberTableProps) => {
  const camerasById = useMemo(
    () =>
      new Map(
        (device ? getDevicesCameras(device) : []).map((camera) => [
          camera.camera_id,
          camera
        ])
      ),
    [device]
  )

  const members = useMemo(
    () => [...group.members].sort((a, b) => a.stream_index - b.stream_index),
    [group.members]
  )

  return (
    <Table withTableBorder withRowBorders>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="deployments.inputSource.camera" />
          </Table.Th>
          <Table.Th w={240}>
            <FormattedMessage id="deployments.list.columns.status" />
          </Table.Th>
          <Table.Th w={160}>
            <FormattedMessage id="deployments.list.columns.actions" />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {members.map((member) => (
          <GroupMemberRow
            key={member.deployment_id}
            member={member}
            group={group}
            camera={camerasById.get(member.stream_id) ?? null}
            deviceActive={device?.active}
            highlighted={member.stream_id === highlightedStreamId}
            renderMemberActions={renderMemberActions}
            onOpenGroup={onOpenGroup}
          />
        ))}
      </Table.Tbody>
    </Table>
  )
}
